export default "__VITE_ASSET__DvebcaXJ__"